import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pickupLocationPlaceholder: {
    description: 'Pickup location placeholder',
    defaultMessage: 'Select Ship From...',
    id: 'bul4oi',
  },
  pickupLocationEmptyPlaceholder: {
    description: 'Pickup location placeholder when there is no options',
    defaultMessage: 'No Ship Froms available.',
    id: 'qHSoB3',
  },
});
